import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap5';
import { useNavigate, Link } from 'react-router-dom';

import routes from 'app/routes';
import Options from 'components/new_ui/Options/Options';
import Item from 'components/new_ui/Options/Item';
import confirmAlert from 'components/new_ui/Alerts/confirm';
import planPrograms from 'data/plan_programs';
import { useContext as usePlansContext } from 'components/Managers/Policy/Context';
import Status from './Status';

export default function Card({ plan }) {
  const navigate = useNavigate();

  const { dispatch: dispatchPlans, actions: actionsPlans, state: statePlans } = usePlansContext();

  const onView = () => {
    navigate(
      routes.managers.plans.show(plan.id),
    );
  };

  const onEdit = () => {
    navigate(
      routes.managers.plans.edit.plan_details(plan.id),
    );
  };

  const onDelete = () => {
    confirmAlert({
      title: 'Delete Plan',
      text: 'Are you sure that you want to delete this plan?',
      confirmButtonText: 'Delete',
    }, () => {
      actionsPlans.deletePlan(dispatchPlans, plan.attributes.enterprise_id, plan.id);
    });
  };

  return (
    <div className="pricing-plan-card">
      <div className="options-wrapper">
        <Status status={plan.attributes.status} />

        <Options className="d-inline-block">
          <Item
            key="view"
            title="View"
            iconClass="summary-icon"
            onClick={onView}
          />

          {plan.attributes.status === 'draft'
            && plan.attributes.payment_mode === 'monthly'
            && !plan.attributes.is_pay_per_used
            && !statePlans.enterprise.attributes.is_lock && (
            <Item
              key="edit"
              title="Edit"
              iconClass="edit-icon"
              onClick={onEdit}
            />
          )}

          {plan.attributes.status === 'draft'
          && !statePlans.enterprise.attributes.is_lock && (
            <Item
              key="delete"
              title="Delete"
              iconClass="trash-icon"
              onClick={onDelete}
            />
          )}
        </Options>
      </div>

      <h4>{plan.attributes.name}</h4>

      <div className="fw-light small">
        {plan.attributes.description}
      </div>

      <hr />

      <Row>
        <Col>
          <small>Programs:</small>
          <br />
          <span className="fw-semibold">
            {planPrograms.find((item) => parseInt(item.value, 10) === plan.attributes.sessions).label}
          </span>
        </Col>
      </Row>

      <Row>
        <Col>
          <small>Payment Method:</small>
          <br />
          <span className="fw-semibold text-one-line">
            {plan.attributes.is_free ? '-' : plan.attributes.payment_information_label}
          </span>
        </Col>
      </Row>

      <Row className="mt-3">
        <Col>
          <small>Effective date:</small>
          <br />
          <span className="fw-semibold">{plan.attributes.effective_date_formatted}</span>
        </Col>

        <Col>
          <small>Renewal date:</small>
          <br />
          <span className="fw-semibold">{plan.attributes.renewal_date_formatted}</span>
        </Col>
      </Row>

      <Row className="mt-3">
        <Col>
          <small>Billing type:</small>
          <br />
          <span className="fw-semibold">{plan.attributes.is_free ? '-' : plan.attributes.billing}</span>
        </Col>

        <Col>
          <small>Members:</small>
          <br />
          <span className="fw-semibold">{plan.attributes.employees_covered}</span>
        </Col>
      </Row>

      <hr />

      <Row className="mt-3 align-items-center">
        {plan.attributes.is_pay_per_used && (
        <Col md={6}>
          <Row>
            <Col md={{ span: 4 }}>
              <small>PPS:</small>
            </Col>
            <Col xs="8" className="text-end">
              <strong>
                {plan.attributes.currency.mark}
                {plan.attributes.price_session}
              </strong>
              {!plan.attributes.is_free && <span className="ms-1 fw-light">{plan.attributes.currency.title}</span>}
            </Col>
          </Row>
        </Col>
        )}

        <Col md={{ span: 6, offset: plan.attributes.is_pay_per_used ? 0 : 6 }}>
          <Row>
            <Col md={{ span: 4 }}>
              <small>PEPM:</small>
            </Col>

            <Col xs="8" className="text-end">
              <strong>
                {plan.attributes.is_free && 'Free'}
                {!plan.attributes.is_free && plan.attributes.currency.mark}
                {!plan.attributes.is_free && plan.attributes.price_employee_month}
              </strong>
              {!plan.attributes.is_free && <span className="ms-1 fw-light">{plan.attributes.currency.title}</span>}

            </Col>
          </Row>
        </Col>
      </Row>

      <Row className="align-items-start">
        {plan.attributes.is_pay_per_used && (
          <Col md={6}>
            <Row>
              <Col>
                <small>PAY AS YOU GO</small>
              </Col>
            </Row>
          </Col>
        )}
        <Col md={{ span: 6, offset: plan.attributes.is_pay_per_used ? 0 : 6 }}>
          <Row>
            <Col md={{ span: 4 }}>
              <small>PREMIUM:</small>
            </Col>

            <Col xs="8" className="text-end">
              <strong className="fs-4">
                {plan.attributes.is_free && 'Free'}
                {!plan.attributes.is_free && plan.attributes.currency.mark}
                {!plan.attributes.is_free && (
                  plan.attributes.payment_mode === 'monthly'
                    ? plan.attributes.monthly_total
                    : plan.attributes.annual_total
                )}
              </strong>
              {!plan.attributes.is_free && (
                <span className="ms-1 fw-light">{plan.attributes.currency.title}</span>
              )}

            </Col>
          </Row>
        </Col>
      </Row>

      <div className="mt-3 text-end">
        <Link
          to={routes.managers.plans.show(plan.id)}
          className="btn btn-primary"
        >
          View
        </Link>
      </div>
    </div>
  );
}

Card.propTypes = {
  plan: PropTypes.object.isRequired,
};
